import { render, staticRenderFns } from "./noAvailableSeats.vue?vue&type=template&id=4206e1f8&"
import script from "./noAvailableSeats.vue?vue&type=script&lang=js&"
export * from "./noAvailableSeats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports